export const compose =
  (...fns) =>
  data =>
    fns.reduceRight((value, acc) => acc(value), data);

// combinators
export const identity = a => a;
export const always = a => () => a;

// string
export const slice = (start, end) => str => str.slice(start, end);

export const cond =
  (...conds) =>
  v => {
    let retVal;
    // eslint-disable-next-line no-restricted-syntax
    for (const c of conds) {
      if (c[0](v)) {
        retVal = c[1](v);
        break;
      }
    }
    return retVal;
  };

export const gte = n => v => v >= n;
export const lte = n => v => v <= n;

export const clamp = (min, max) =>
  cond([lte(min), always(min)], [gte(max), always(max)], [always(true), identity]);

export const unique = array => [...new Set(array)];

/**
 * Mouse wheel normalizer
 * Based on Facebook's attempt to normalize Mouse Wheel scrolling accross different platforms.
 * https://github.com/facebookarchive/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
 *
 * @param {Object} event Event handler data
 */
export const normalizeWheel = event => {
  const PIXEL_STEP = 10;
  const LINE_HEIGHT = 40;
  const PAGE_HEIGHT = 800;
  let sX = 0;
  let sY = 0; // spinX, spinY
  let pX = 0;
  let pY = 0; // pixelX, pixelY

  // Legacy
  if ('detail' in event) {
    sY = event.detail;
  }
  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }
  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }
  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  }

  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }
  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }
  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return { spinX: sX, spinY: sY, pixelX: pX, pixelY: pY };
};

export const isViewingArticle = location => {
  const articlePath = '/article/';
  return location.pathname.includes(articlePath);
};

export const isViewingHomepage = location => {
  const homepagePath = '/decode';
  return location.pathname === homepagePath;
};
